export default __webpack_public_path__ + "static/media/dziecko_2.ed25525e.svg";